<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';

    @Component({
        props: {
            workspaceId: {
                type: Number,
                required: true
            },
            projectId: {
                type: Number,
                required: true
            }
        }
    })
    export default class PortfolioNavigation extends Vue
    {

    }
</script>

<template>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark" style="margin-bottom: 0;">
        <a class="navbar-brand" v-sanitizedHref="`/#/alternatives/kanban/${workspaceId}/${projectId}`">Portfolio</a>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navBar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navBar">
            <ul class="navbar-nav mr-auto">

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Projects
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" v-sanitizedHref="`/#/portfolio-projects/proposals/${workspaceId}/${projectId}`">Proposals</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/portfolio-projects/scheduled/${workspaceId}/${projectId}`">Scheduled</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/portfolio-projects/started/${workspaceId}/${projectId}`">Started</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/portfolio-projects/finished/${workspaceId}/${projectId}`">Finished</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/portfolio-projects/all/${workspaceId}/${projectId}`">All</a>

                    </div>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Manage
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" v-sanitizedHref="`/#/pp/attributes/${workspaceId}/${projectId}`">Attributes</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/pp/forms/${workspaceId}/${projectId}`">Forms</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/pp/lists-manager/${workspaceId}/${projectId}`">Lists</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/pp/notifications/${workspaceId}/${projectId}`">Notifications</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/pp/dependencies/${workspaceId}/${projectId}`">Dependencies</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/pp/pages/${workspaceId}/${projectId}`">Request pages</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/pp/people/${workspaceId}/${projectId}`">People</a>
                    </div>
                </li>

                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/pp/goals/${workspaceId}/${projectId}`">Evaluation</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/pp/assessments/${workspaceId}/${projectId}`">Assessments</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/portfolio-plans/${workspaceId}/${projectId}`">Planning</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/pp/reports/${workspaceId}/${projectId}`">Reports</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/portfolio/pnl/${workspaceId}/${projectId}`">P&L</a>
                </li>
            </ul>
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Account
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" v-sanitizedHref="`/#/projects/${workspaceId}`">Back to workspace</a>
                        <a class="dropdown-item" href="/#/organizations/users/dashboard">My dashboard</a>
                        <a class="dropdown-item" href="/#/organizations/users/account">Manage your account</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/organizations/sessions/close">Sign out</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<style scoped>
    .navbar {
        -webkit-box-shadow: 0 2px 6px 0 #999;
        -moz-box-shadow: 0 2px 6px 0 #999;
        box-shadow: 0 2px 6px 0 #999;
    }
</style>